import React from "react";

export function GreecePrivacyGreekBody() {
  return (
<>
      <h1>ΠΟΛΙΤΙΚΗ ΑΠΟΡΡΗΤΟΥ</h1>

      <h1>1. Πολιτική Απορρήτου: Στόχοι και πεδίο εφαρμογής</h1>
      <p className="fs-4">
        Η παρούσα Πολιτική Απορρήτού αναφέρεται στην παροχή Υπηρεσιών της
        εταιρεία με την επωνυμία Smart Mobile Tech – FZCO, η οποία εδρεύει
        DSO-THUB-G-D-FLEX-G003E , building THUB, Dubai Silicon Oasis , Dubai με
        ΑΦΜ 100606110300003 και αριθμό εγγραφής DSO-FZCO- 2420 στο οικείο
        Εμπορικό Επιμελητήριο (εφεξής, στην παρούσα θα καλείται η «Εταιρεία»).
      </p>
      <p className="fs-4">
        Σκοπός της παρούσας Πολιτικής Απορρήτου αποτελεί η περιγραφή του τρόπου
        συλλογής και επεξεργασίας των προσωπικών δεδομένων, τα οποία
        λαμβάνονται, μέσω διαδικτύου ή με άλλους τρόπους καθώς επίσης, και οι
        πρακτικές απορρήτου της Εταιρείας.
      </p>
      <p className="fs-4">
        Η Εταιρεία δεσμεύεται να λαμβάνει όλα τα κατάλληλα μέτρα προκειμένου να
        προστατεύει και να επεξεργάζεται νόμιμα τα προσωπικά δεδομένα, όπως
        προβλέπεται από τον Γενικό Κανονισμό Προστασίας Προσωπικών Δεδομένων της
        ΕΕ 679/2016 (ΓΚΠΔ) και τους κατ' ιδίαν συναφείς Νόμους εφαρμογής του.
      </p>
      <p className="fs-4">
        Οι Υπηρεσίες που παρέχονται από την Εταιρεία απευθύνονται σε ενήλικες
        και ως εκ τούτου, δεν συλλέγονται προσωπικές πληροφορίες από πρόσωπο, το
        οποίο είναι γνωστό ότι είναι κάτω των 18 ετών, χωρίς την προηγούμενη
        επαληθεύσιμη συγκατάθεση του ασκούντος την γονική μέριμνα. Σε κάθε
        περίπτωση, ο ασκών τη γονική μέριμνα έχει το δικαίωμα, κατόπιν αιτήματος
        του, να ενημερωθεί για τις πληροφορίες που δόθηκαν από τον ανήλικο και/ή
        να ζητήσει την διαγραφή τους. Εφόσον γίνει αντιληπτό από την Εταιρεία
        ότι ένα άτομο, το οποίο υποβάλλει τα προσωπικά του δεδομένα, είναι
        μικρότερο των 18 ετών, θα προβεί άμεσα στη διαγραφή τους.
      </p>
      <p className="fs-4">
        Η εν λόγω Πολιτική Απορρήτου ενσωματώνεται στους ''Γενικούς Όρους &
        Προϋποθέσεις'', οι οποίοι είναι αναρτημένοι στην ιστοσελίδα της
        Εταιρείας, με τους οποίους αποτελούν ενιαίο κείμενο. Οι δραστηριότητες
        της Εταιρείας διεξάγονται μέσω του ιστότοπου
        https://www.mobileartsme.com/
      </p>

      <h1>2. Ορισμοί</h1>
      <p className="fs-4">
        <strong>Προσωπικά Δεδομένα:</strong> κάθε πληροφορία που αφορά
        ταυτοποιημένο ή ταυτοποιήσιμο φυσικό πρόσωπο. Το ταυτοποιήσιμο φυσικό
        πρόσωπο είναι εκείνο του οποίου η ταυτότητα μπορεί να εξακριβωθεί, άμεσα
        ή έμμεσα, ιδίως μέσω αναφοράς σε αναγνωριστικό στοιχείο ταυτότητας, όπως
        όνομα, σε αριθμό ταυτότητας, σε δεδομένα θέσης, σε έναν ή περισσότερους
        παράγοντες που προσιδιάζουν στη σωματική, φυσιολογική, ψυχολογική,
        οικονομική, πολιτιστική ή κοινωνική ταυτότητα του.
      </p>
      <p className="fs-4">
        <strong>Υποκείμενο Δεδομένων:</strong> κάθε φυσικό πρόσωπο του οποίου τα
        προσωπικά δεδομένα αποτελούν αντικείμενο επεξεργασίας από ή για
        λογαριασμό της Εταιρείας.
      </p>
      <p className="fs-4">
        <strong>Επεξεργασία:</strong> οποιαδήποτε δραστηριότητα που περιλαμβάνει
        προσωπικά δεδομένα, ανεξάρτητα από τα μέσα και τη διαδικασία που
        εφαρμόζεται, π.χ. η συλλογή, αποθήκευση, χρήση, αναθεώρηση, αποκάλυψη,
        αρχειοθέτηση, προβολή και καταστροφή προσωπικών δεδομένων.
      </p>
      <p className="fs-4">
        <strong>Περιορισμός της επεξεργασίας:</strong> η επισήμανση
        αποθηκευμένων δεδομένων προσωπικού χαρακτήρα με στόχο τον περιορισμό της
        επεξεργασίας τους στο μέλλον
      </p>
      <p className="fs-4">
        <strong>Κατάρτιση προφίλ:</strong> οποιαδήποτε μορφή αυτοματοποιημένης
        επεξεργασίας δεδομένων προσωπικού χαρακτήρα που συνίσταται στη χρήση
        δεδομένων προσωπικού χαρακτήρα για την αξιολόγηση ορισμένων προσωπικών
        πτυχών ενός φυσικού προσώπου.
      </p>
      <p className="fs-4">
        <strong>Σύστημα αρχειοθέτησης:</strong> κάθε διαρθρωμένο σύνολο
        δεδομένων προσωπικού χαρακτήρα τα οποία είναι προσβάσιμα με γνώμονα
        συγκεκριμένα κριτήρια, είτε το σύνολο αυτό είναι συγκεντρωμένο είτε
        αποκεντρωμένο είτε κατανεμημένο σε λειτουργική ή γεωγραφική βάση.
      </p>
      <p className="fs-4">
        <strong>Διαβίβαση:</strong> η πρόσβαση στα προσωπικά δεδομένα, για
        παράδειγμα επιτρέποντας πρόσβαση, μετάδοση ή δημοσίευση.
      </p>
      <p className="fs-4">
        <strong>Υπεύθυνος επεξεργασίας:</strong> το φυσικό ή νομικό πρόσωπο που
        αποφασίζει για το σκοπό, τον τρόπο, το περιεχόμενο και τη διαδικασία
        επεξεργασίας δεδομένων προσωπικού χαρακτήρα.
      </p>
      <p className="fs-4">
        <strong>Εκτελών την επεξεργασία:</strong> το φυσικό ή νομικό πρόσωπο που
        επεξεργάζεται δεδομένα προσωπικού χαρακτήρα σύμφωνα με τις οδηγίες του
        υπεύθυνου επεξεργασίας δεδομένων.
      </p>
      <p className="fs-4">
        <strong>Συγκατάθεση του υποκειμένου των δεδομένων:</strong> κάθε ένδειξη
        βουλήσεως, ελεύθερη, συγκεκριμένη, ρητή και εν πλήρει επιγνώσει, με την
        οποία το υποκείμενο των δεδομένων εκδηλώνει ότι συμφωνεί, με δήλωση ή με
        σαφή θετική ενέργεια, να αποτελέσουν αντικείμενο επεξεργασίας τα
        δεδομένα προσωπικού χαρακτήρα που το αφορούν.
      </p>

      <h1>3. Σκοπός Επεξεργασίας των Δεδομένων</h1>
      <p className="fs-4">
        Η επεξεργασία των προσωπικών δεδομένων από την Εταιρεία γίνεται
        αποκλειστικά για τον σκοπό που υποδεικνύεται κατά την στιγμή της
        συλλογής στα πλαίσια παροχής των Υπηρεσιών της Εταιρείας καθώς και για
        κάθε νόμιμο σκοπό.
      </p>
      <p className="fs-4">
        Οι συλλεχθείσες πληροφορίες προσωπικού χαρακτήρα, που συλλέγονται από
        την Εταιρεία, διευκολύνουν την δημιουργία ή βελτίωση και την
        εξατομίκευση της σχέσης της Εταιρείας με τους αποδέκτες των Υπηρεσιών
        της.
      </p>
      <p className="fs-4">
        Η επεξεργασία των προσωπικών δεδομένων γίνεται πάντοτε στα πλαίσια του
        Νόμου και σύμφωνα με τις αρχές της καλής πίστης. Γι' αυτό τον λόγο τα
        προσωπικά δεδομένα που συλλέγονται ή αποθηκεύονται είναι μόνο όσα
        κρίνονται απαραίτητα για την εκπλήρωση του σκοπού της επεξεργασίας τους.
        Επίσης, η Εταιρεία λαμβάνει όλα τα κατάλληλα μέτρα προς διασφάλιση της
        νομιμότητας της επεξεργασίας, η οποία πρέπει να ανταποκρίνεται στον
        σκοπό συλλογής των προσωπικών δεδομένων.
      </p>
      <p className="fs-4">
        Το σύννομο της επεξεργασίας των προσωπικών δεδομένων για το συγκεκριμένο
        σκοπό βασίζεται στη συγκατάθεση του Τελικού Χρήστη, σύμφωνα με το άρθρο
        6 παράγραφος 1 στοιχείο α και άρθρο 9 παράγραφος 2 στοιχείο α του
        κανονισμού GDPR, και στην εκτέλεση της σύμβασης στην οποία είναι
        συμβαλλόμενο μέρος, ως υποκείμενο των δεδομένων (άρθρο 6 παράγραφος 1
        στοιχείο β Κανονισμού GDPR)·
      </p>

      <h1>4. Είδη Προσωπικών Δεδομένων που συλλέγονται</h1>
      <p className="fs-4">
        Το είδος προσωπικών δεδομένων που συλλέγονται συμπεριλαμβάνει το πλήρες
        ονοματεπώνυμό, την ηλεκτρονική διεύθυνση, πληροφορίες χρέωσης ή αριθμό
        κινητού τηλεφώνου και παρόμοια δεδομένα, όπως αυτά μπορεί να ζητηθούν
        ανά διαστήματα. Σε κάθε περίπτωση απαραίτητη προϋπόθεση της συλλογής και
        επεξεργασίας των προσωπικών σας δεδομένων είναι η ρητή παροχή
        συγκατάθεσης εκ μέρους σας.
      </p>

      <h1>5. Τρόποι Συλλογή των Προσωπικών Δεδομένων</h1>
      <p className="fs-4">
        Η συλλογή των προσωπικών δεδομένων πραγματοποιείται είτε με την
        αυτόβουλη παροχή τους στην Εταιρεία από εσάς, είτε με αυτόματα μέσα.
        Ειδικότερα:
      </p>

      <h3>
        • Παροχή Προσωπικών Πληροφοριών από τα ίδια τα Υποκείμενα των Δεδομένων
      </h3>
      <p className="fs-4">
        Η Εταιρεία συλλέγει προσωπικά δεδομένα, εσείς υποβάλλετε αυτοβούλως
        προσωπικές σας πληροφορίες. Το παραπάνω συντρέχει στις εξής περιπτώσεις:
      </p>
      <ul>
        <li>
          κατά την εγγραφή σας στον Ιστότοπο της Εταιρείας για λήψη Υπηρεσιών
          ψυχαγωγικού περιεχομένου κινητών τηλεφώνων, όπως ήχους ειδοποιήσεων,
          παιχνίδια, φωτογραφίες, ειδήσεις και άλλα αντικείμενα,
        </li>
        <li>
          κατά την πραγματοποίηση σύνδεσης σας με την επιλογή της λήψης αρχείων
          της Εταιρείας, χωρίς εγγραφή, στην ιστοσελίδα
          https://www.mobileartsme.com/, όπως στην περίπτωση των Μεμονωμένων
          Λήψεων ή Συνδρομών μέσω SMS με την χρήση του κινητού σας τηλεφώνου,
        </li>
        <li>
          με την υποβολή από εσάς απόψεων, προτάσεων, παρατηρήσεων ή παραπόνων
          στην Εταιρεία ή μέσω κάθε επικοινωνίας που πραγματοποιείται με την
          Εταιρεία,
        </li>
        <li>
          κατά την υποβολή δήλωσης συμμετοχής σας σε δραστηριότητες της
          Εταιρείας όπως διαγωνισμούς, παιχνίδια, έρευνες, φόρουμ,
        </li>
        <li>
          με την μεταφορά των προσωπικών σας δεδομένων από τρίτα μέρη με τα
          οποία η Εταιρεία συνεργάζεται και είναι αξιόπιστα. Η μεταφορά αυτή
          πραγματοποιείται στα πλαίσια επίτευξης του σκοπού για τον οποίο
          υποβάλλατε τα προσωπικά σας δεδομένα, δίνοντας την σχετική συγκατάθεση
          σας,
        </li>
        <li>
          μεταφορά των προσωπικών σας δεδομένων στην Εταιρεία από δημόσιες
          βάσεις δεδομένων.
        </li>
      </ul>

      <h3>
        • Συλλογή Προσωπικών Πληροφοριών μέσω Αυτοματοποιημένων Μέσων
        (Cookies)-Πολιτική της Εταιρείας
      </h3>
      <p className="fs-4">
        Τα cookies αποτελούν μικρά αρχεία κειμένου τα οποία χρησιμοποιούνται για
        την αποθήκευση δεδομένων σχετικά με εσάς και τις προτιμήσεις σας. Κάθε
        φορά που πραγματοποείτε περιήγηση σε συγκεκριμένες ιστοσελίδες,
        τοποθετούνται αυτόματα σε προκαθορισμένο φάκελο του υπολογιστή σας, από
        τον διακομιστή. Σκοπός των cookies είναι να διακρίνουν μοναδικά τον
        υπολογιστή σας στον διακομιστή. Με αυτό τον τρόπο δίνεται η δυνατότητα
        στην Εταιρεία να συλλέγει πληροφορίες σε σχέση με τον διακομιστή ώστε να
        διευκολύνεται η περιήγηση σας στο διαδίκτυο, η αξιολόγηση και ο έλεγχος
        της λειτουργίας της ιστοεσλίδας.
      </p>
      <p className="fs-4">
        Με την χρήση των cookies η Εταιρεία μπορεί να αναγνωρίσει το πρόγραμμα
        περιήγησής σας στο διαδίκτυο και να προσδιορίσει εάν έχει εγκαταστήσει
        το λογισμικό ενεργοποίησης που απαιτείται για πρόσβαση σε συγκεκριμένο
        υλικό στις τοποθεσίες της Εταιρείας στο διαδίκτυο. Επίσης, μέσω των
        cookies η Εταιρεία μπορεί να προσδιορίσει το συνολικό αριθμό επισκεπτών
        στην ιστοσελίδα της και να σας αναγνωρίσει όταν επιστρέψετε στον
        ιστότοπο της. Πληροφορίες σχετικά με τις δραστηριότητές σας στον
        ιστότοπο της Εταιρείας και άλλα μη προσωπικά δεδομένα σας, είναι δυνατό
        να χρησιμοποιηθούν, ώστε να εμφανίζονται μόνο οι ηλεκτρονικές
        διαφημίσεις που η Εταιρεία θεωρεί ότι ανταποκρίνονται στα ενδιαφέροντα
        σας.
      </p>
      <p className="fs-4">
        Τα cookies έχουν την δυνατότητα να αποθηκεύουν τον κωδικό πρόσβασής σας
        σε μια τοποθεσία για εύκολη σύνδεση, την οποία έχετε προηγουμένως
        επισκεφθεί καθώς επίσης να αποθηκεύσουν δεδομένα σχετικά με τις
        προτιμήσεις σας, για να σας παραπέμψουν σε μια προσαρμοσμένη σε αυτές
        ιστοσελίδα.
      </p>
      <p className="fs-4">
        Αναγνωρίσιμες πληροφορίες σχετικά με την ταυτότητα σας δεν είναι δυνατόν
        να συλλεχθούν μέσω των cookies ή άλλων συναφών μέσων αναγνώρισης. Το
        παραπάνω συμβαίνει αποκλειστικά και μόνο στην περίπτωση που ο Τελικός
        Χρήστης οικειοθελώς υποβάλλει αναγνωρίσιμη πληροφορία, οπότε τα
        αυτοματοποιημένα μέσα θα χρησιμοποιηθούν για να δώσουν περαιτέρω
        πληροφορίες σχετικά με την χρήση που πραγματοποιείτε στις ιστοσελίδες
        και/ή τα διαδραστικά (interactive) ηλεκτρονικά μηνύματα, με μοναδικό
        σκοπό να αυξηθεί η χρησιμότητά τους για εσάς. Τέτοιες περιπτώσεις
        ενδεικτικά αποτελούν η υποβολή αίτησης εγγραφής στις Υπηρεσίες της
        Εταιρείας ή η αποστολή ηλεκτρονικού μηνύματος.
      </p>
      <p className="fs-4">
        Στην πλειοψηφία του τα προγράμματα περιήγησης (browsers) είναι
        προγραμματισμένα να δέχονται cookies. Ωστόσο, υπάρχει η δυνατότητα να
        ρυθμίσετε το δικό σας πρόγραμμα περιήγησης κατά τέτοιο τρόπο ώστε να
        αρνείται την λήψη των cookies ή να ειδοποιείσθε κάθε φορά που λαμβάνει
        ένα cookie. Σημειώνεται ότι στη τελευταία περίπτωση είναι πιθανό
        ορισμένα μέρη της ιστοσελίδας να μην λειτουργήσουν σωστά σε περίπτωση
        που έχετε επιλέξει την απόρριψη των cookies και να μην έχετε πρόσβαση σε
        ορισμένες δυνατότητες.
      </p>
      <p className="fs-4">
        Είναι εφικτό, επίσης, η Εταιρεία να χρησιμοποιήσει cookies ή παρόμοια
        εργαλεία για να συσχετίσει τη χρήση του ιστότοπού της από εσάς με
        προσωπικά δεδομένα που λαμβάνονται από την ίδια ή ένα τρίτο μέρος,
        αξιόπιστο συνεργάτη της Εταιρείας.
      </p>
      <p className="fs-4">
        Το παραπάνω μπορεί να συμβεί ενδεικτικά στην περίπτωση που έχετε ζητήσει
        από την Εταιρεία την αποστολή πληροφοριών σχετικά με μελλοντικά προϊόντα
        ή προωθητικές ενέργειές της Εταιρείας, cookies ή/και ιστορικό περιήγησης
        στο διαδίκτυο σχετικά με τις δραστηριότητές σας στον ιστότοπό της
        Εταιρείας μπορεί να της επιτρέψουν να περιορίσει το υλικό που σας
        παρέσει σε αυτό που θεωρεί ότι θα βρείτε ενδιαφέρον, με βάση τις
        προηγούμενες ηλεκτρονικές σας δραστηριότητες και προτιμήσεις. Στην πιο
        πάνω περίπτωση που η εταιρεία επιθυμεί να συνδυάσει τα προσωπικά
        δεδομένα σας και cookies ή πληροφορίες ιστορικού περιήγησης στο
        διαδίκτυο με αυτόν τον τρόπο, θα λάβει απαραίτητα την προηγούμενη ρητή
        συγκατάθεσή σας.
      </p>
      <p className="fs-4">
        Στην ιστοσελίδα της Εταιρείας ενδέχεται να εμφανίζονται διαφημίσεις
        τρίτων, οι οποίες μπορούν, επίσης, να περιέχουν cookies. Τα συγκεκριμένα
        cookies ορίζονται από τον εκάστοτε διαφημιστή ή τον διαφημιζόμενο και η
        Εταιρεία δεν έχει την δυνατότητα να τα ελέγχει. Ως εκ τούτου, θα πρέπει
        να ελέγχετε την πολιτική απορρήτου του διαφημιστή ή διαφημιζόμενου,
        προκειμένου να διαπιστώσετε εάν γίνεται χρήση cookies και με ποιον
        τρόπο.
      </p>
      <p className="fs-4">
        Τέλος, οι τεχνικές υπηρεσίες και άλλες υπηρεσίες της Εταιρείας ή
        συνεργάτες της δύνανται να συλλέγουν πληροφορίες σχετικά με τους
        επισκέπτες της ιστοσελίδας της Εταιρείας αυτόματα με σκοπό την
        συντήρηση, τη βελτίωση, ασφάλεια και άλλες νόμιμες αιτίες. Τέτοιες
        πληροφορίες μπορεί να περιλαμβάνουν τη διεύθυνση IP επισκεπτών, τον τύπο
        προγράμματος περιήγησης, την ημερομηνία, την ώρα και τη διάρκεια της
        επίσκεψης και συγκεκριμένες σελίδες που επισκεφθήκατε.
      </p>

      <h1>
        6. Πρακτικές της Εταιρείας αναφορικά με την συλλογή των Προσωπικών
        Δεδομένων και την ενημέρωση σας
      </h1>
      <p className="fs-4">
        Κάθε φορά που παρέχετε τα προσωπικά σας Δεδομένα, η Εταιρεία διασφαλίζει
        ότι έχετε ενημερωθεί για το ποιος συλλέγει τις προσωπικές σας
        πληροφορίες, τον τρόπο συλλογής τους, το είδος της χρήσης που θα
        πραγματοποιηθεί από την Εταιρεία καθώς και τον σκοπό της συλλογής τους.
      </p>
      <p className="fs-4">
        Για αυτό τον λόγο κάθε φορά που παρέχετε τα προσωπικά σας δεδομένα, η
        Εταιρεία θα φροντίζει να σας ειδοποιεί σχετικά με τις επιλογές σας ως
        προς την χρήση των προσωπικών δεδομένων σας, καθώς και σε περίπτωση
        κοινής χρήσης των δεδομένων σας από την Εταιρεία με τρίτες εταιρείες.
      </p>
      <p className="fs-4">
        Όταν τα προσωπικά σας δεδομένα συλλέγονται χειροκίνητα ή με τρόπους μη
        συνδεόμενους με το διαδίκτυο (π.χ φόρμα συνδρομής), η Εταιρεία φροντίζει
        για την αποστολή σε εσάς μίας σύντομης ειδοποίησης, όπου θα περιγράφεται
        ο τρόπος λήψης του πλήρους κειμένου της παρούσας Πολιτικής και των άλλων
        πληροφοριών της Εταιρείας. Κατά αυτό τον τρόπο εξασφαλίζεται η αναλυτική
        ενημέρωση σας ως προς όλα τα ζητήματα που αφορούν τα προσωπικά σας
        δεδομέναν και την χρήση τους από την Εταιρεία, προκειμένου να παράσχετε
        στην Εταιρεία την ρητή συγκατάθεση σας.
      </p>
      <p className="fs-4">
        Στον ιστότοπο της Εταιρείας ενδέχεται να εμφανίζονται σύνδεσμοι που
        οδηγούν σε ιστότοπους άλλων εταιρειών. Σε κάποιες από τις παραπάνω
        περιπτώσεις, ενδέχεται οι τοποθεσίες τρίτων να φέρουν το λογότυπο της
        Εταιρείας, χωρίς ωστόσο η Εταιρεία να έχει την διαχείριση ή την ευθύνη
        για το περιεχόμενο αυτών των ιστότοπων.
      </p>
      <p className="fs-4">
        Στον ιστότοπο της Εταιρείας ενδέχεται να εμφανίζονται διαφημίσεις άλλων
        εταιρειών, στις ιστοσελίδες των οποίων μπορείτε να μεταφερθείτε μέσω
        συνδέσμου που εμφανίζεται στον ιστότοπο της Εταιρείας. Σε αυτήν την
        περίπτωση, η Εταιρεία δεν φέρει ευθύνη για τις πρακτικές που ακολουθούν
        τα τρίτα μέρη ή για τις πολιτικές απορρήτου τρίτων μερών ή τοπικών
        διαφημιστικών εταιρειών στο Internet. Έτσι, σε περίπτωση που
        ανακατευθυνθείτε από τον ιστότοπο της Εταιρείας μέσω ενός τέτοιου
        συνδέσμου ή με την επιλογή μιας διαφήμισης, στην ιστοσελίδα τρίτης
        εταιρείας, οφείλετε να ελέγξετε την ισχύουσα πολιτική απορρήτου του
        τρίτου μέρους ή τοποθεσίας διαφημιστή, ώστε να ενημερωθείτε για τον
        τρόπο που θα επεξεργαστούν οποιαδήποτε εκ των προσωπικών σας δεδομένων
        συλλέξουν.
      </p>

      <h1>7. Δικαιώματα των Υποκειμένων των Προσωπικών Δεδομένων</h1>
      <p className="fs-4">
        Κάθε υποκείμενο δεδομένων έχει τα ακόλουθα δικαιώματα σύμφωνα με το ΓΚΠΔ
        τα οποία η Εταιρεία σέβεται και προστατεύει:
      </p>
      <p className="fs-4">
        <strong>α) Το δικαίωμα ενημέρωσης:</strong> το υποκείμενο δικαιούται
        μετά από αίτημα του να λάβει πληροφορίες σχετικά με τα προσωπικά
        δεδομένα του που τηρούνται από την Εταιρεία και συγκεκριμένα, το είδος
        των δεδομένων που έχουν υποβληθεί σε επεξεργασία, ποια πρόσωπα έχουν
        δικαίωμα επεξεργασίας και τους λόγους αυτής
      </p>
      <p className="fs-4">
        <strong>β) Το δικαίωμα πρόσβασης:</strong> το υποκείμενο έχει το
        δικαίωμα να ζητήσει από την Εταιρεία δωρεάν πρόσβαση στα προσωπικά
        δεδομένα που διαθέτει η τελευταία,
      </p>
      <p className="fs-4">
        <strong>γ) Το δικαίωμα διόρθωσης και συμπλήρωσης:</strong> Το υποκείμενο
        δικαιούται, κατόπιν σχετικής ειδοποίησης του προς την Εταιρεία, να
        αιτηθεί την διόρθωση τυχόν ανακριβών προσωπικών δεδομένων που το αφορούν
        καθώς και την συμπλήρωση ατελών δεδομένων του, υπό την προϋπόθεση ότι τα
        δεδομένα αυτά είναι αναγκαία για τους σκοπούς επεξεργασίας τους,
      </p>
      <p className="fs-4">
        <strong>δ) Το δικαίωμα διαγραφής:</strong> Το υποκείμενο δικαιούται
        κατόπιν σχετικού αιτήματος του προς την Εταιρεία, να ζητήσει την
        διαγραφή των προσωπικών δεδομένων του που τηρούνται από την Εταιρεία.
        Ωστόσο, κάποια εκ των προσωπικών δεδομένων του υποκειμένου θα
        διαγράφονται μόνο μετά από μια καθορισμένη περίοδο διακράτησης, ιδίως
        επειδή σε ορισμένες περιπτώσεις η Εταιρεία υποχρεούται εκ του νόμου να
        διατηρεί τα δεδομένα, ή επειδή τα δεδομένα απαιτούνται για την εκπλήρωση
        των συμβατικών υποχρεώσεων της Εταιρείας απέναντι στο υποκείμενο.
      </p>
      <p className="fs-4">
        <strong>ε) Το δικαίωμα περιορισμού της επεξεργασίας:</strong> Το
        Υποκείμενο έχει δικαίωμα να ζητήσει τον περιορισμό της επεξεργασίας των
        προσωπικών του δεδομένων και ειδικότερα: 1) όταν αμφισβητείται η
        ακρίβειά τους, 2) η επεξεργασία είναι παράνομη, 3) τα δεδομένα δεν
        χρειάζονται πλέον στον υπεύθυνο επεξεργασίας, 4) έχει αντιρρήσεις ως
        προς την αυτοματοποιημένη επεξεργασία.
      </p>
      <p className="fs-4">
        <strong>στ) Το δικαίωμα στη φορητότητα δεδομένων:</strong> Το υποκείμενο
        δικαιούται να ζητήσει την μεταφορά των δεδομένων του σε άλλον υπεύθυνο
        επεξεργασίας
      </p>
      <p className="fs-4">
        <strong>ζ) Το δικαίωμα αντίρρησης:</strong> Το υποκείμενο μπορεί ανά
        πάσα στιγμή να προβάλλει αντιρρήσεις κατά της επεξεργασίας των
        προσωπικών δεδομένων του στο μέλλον, εάν η Εταιρεία επεξεργάζεται τα
        δεδομένα του στη βάση μίας εκ των νομικών αιτιολογήσεων που προβλέπονται
        στο άρθρο 6 (1ε ή 1στ) του Κανονισμού (ΕΕ) 2016/679. Εάν το υποκείμενο
        υποβάλλει αντιρρήσεις, η Εταιρεία θα σταματήσει την επεξεργασία των
        δεδομένων του, υπό την προϋπόθεση ότι δεν συντρέχουν νόμιμοι λόγοι για
        περαιτέρω επεξεργασία τους. Η επεξεργασία των δεδομένων του υποκειμένου
        για σκοπούς διαφήμισης δεν συνιστά νόμιμο λόγο.
      </p>
      <p className="fs-4">
        <strong>
          η) Δικαιώματα σχετικά με την αυτοματοποιημένη λήψη αποφάσεων και τη
          δημιουργία προφίλ:
        </strong>{" "}
        Το υποκείμενο των δεδομένων έχει το δικαίωμα να μην υπόκειται σε απόφαση
        που λαμβάνεται αποκλειστικά βάσει αυτοματοποιημένης επεξεργασίας,
        συμπεριλαμβανομένης της κατάρτισης προφίλ, η οποία παράγει έννομα
        αποτελέσματα που το αφορούν ή το επηρεάζει σημαντικά με παρόμοιο τρόπο.
        Τα παραπάνω δεν ισχύουν όταν η απόφαση: 1) είναι αναγκαία για τη σύναψη
        ή την εκτέλεση σύμβασης μεταξύ του υποκειμένου των δεδομένων και του
        υπευθύνου επεξεργασίας των δεδομένων, 2) επιτρέπεται από το δίκαιο της
        Ένωσης ή το δίκαιο κράτους μέλους στο οποίο υπόκειται ο υπεύθυνος
        επεξεργασίας ή 3) βασίζεται στη ρητή συγκατάθεση του υποκειμένου των
        δεδομένων.
      </p>
      <p className="fs-4">
        <strong>θ) Δικαίωμα ανάκλησης της συγκατάθεσής:</strong> Το υποκείμενο
        έχει ανά πάσα στιγμή το δικαίωμα να ανακαλέσει τη συγκατάθεσή του για
        την επεξεργασία των προσωπικών δεδομένων του στο μέλλον. Η νομιμότητα
        της επεξεργασίας των δεδομένων του υποκειμένου παραμένει ανεπηρέαστη από
        την ενέργεια αυτή, έως το σημείο ανάκλησης της συγκατάθεσής του.
      </p>
      <p className="fs-4">
        <strong>ι) Δικαίωμα δέσμευσης των προσωπικών δεδομένων σας:</strong> Σε
        ορισμένες περιπτώσεις που προβλέπονται από το νόμο, η Εταιρεία θα
        δεσμεύει τα δεδομένα των υποκειμένων, εάν υποβάλλουν σχετικό αίτημα.
        Περαιτέρω επεξεργασία δεσμευμένων δεδομένων γίνεται μόνο σε πολύ
        περιορισμένη έκταση.
      </p>
      <p className="fs-4">
        Εάν το Υποκείμενο ζητήσει από την Εταιρεία την διακοπή χρήσης των
        προσωπικών δεδομένων του, η Εταιρεία θα ικανοποιήσει αυτό το αίτημα,
        διατηρώντας μόνο τις πληροφορίες που είναι απαραίτητες για τη συμμόρφωση
        με την ισχύουσα εθνική νομοθεσία.
      </p>
      <p className="fs-4">
        Το υποκείμενο μπορεί να επικοινωνήσει με την Εταιρεία για να ασκήσει τα
        δικαιώματά του και η Εταιρεία θα ανταποκριθεί σε εύλογο χρονικό
        διάστημα, όχι σε περισσότερο από 30 ημέρες.
      </p>

      <h1>
        8. Χρήση και Επεξεργασία των Προσωπικών Δεδομένων από την Εταιρεία
      </h1>
      <p className="fs-4">
        Η Εταιρεία δεσμεύεται ότι η χρήση των παρεχόμενων προσωπικών δεδομένων
        θα πραγματοποιείται κατά τρόπο σύμφωνο με την παρούσα Πολιτική και
        αποκλειστικά και μόνο για τους σκοπούς για τους οποίους υποβλήθηκαν τα
        προσωπικά δεδομένα.
      </p>
      <p className="fs-4">
        Η Εταιρεία διατηρεί την δυνατότητα χρήσης των προσωπικών δεδομένων που
        της παρείχατε κατά την εγγραφή σας στις Υπηρεσίες της, προκειμένου να
        σας στείλει σημαντικές πληροφορίες και ενημερώσεις σχετικά με τον
        λογαριασμό σας και την παροχή των υπηρεσιών που ζητήσατε.
      </p>
      <p className="fs-4">
        Στην περίπτωση συλλογής προσωπικών δεδομένων από το ίδιο το υποκείμενο
        κατά την υποβολή αιτήματός του στην Εταιρεία για λήψη αρχείων και
        υπηρεσιών της, η Εταιρεία θα προχωρήσει σε επεξεργασία του αιτήματος
        συνδρομής ή παροχής υπηρεσίας προς το υποκείμενο, συμπεριλαμβανομένης
        και της επεξεργασίας εκπλήρωσης παραγγελίας και πληρωμής, εάν υπάρχει.
        Ως εκ τούτου, η Εταιρεία δεν θα προχωρήσει σε διαμοιρασμό των στοιχείων
        με τρίτα μέρη, εκτός από εκείνα των οποίων η χρήση είναι απαραίτητη για
        την εκτέλεση εργασιών (όπως εκπλήρωση παραγγελίας και επεξεργασία
        πληρωμής), με σκοπό την ολοκλήρωση αγορών που πραγματοποιεί το
        υποκείμενο των δεδομένων και συνδρομών που αιτείται μέσω του
        https://www.mobileartsme.com/.
      </p>

      <h1>9. Διαβίβαση των Προσωπικών Δεδομένων σε τρίτα μέρη</h1>
      <p className="fs-4">
        Η Εταιρεία δεσμεύεται να μην διαβιβάσει τα προσωπικά δεδομένα που
        συλλέγει σε τρίτα μέρη που δεν σχετίζονται και δεν συνεργάζονται μαζί
        της, εκτός εάν λάβει την ρητή συγκατάθεση σας. Εάν η Εταιρεία λάβει
        προσωπικά δεδομένα από ένα τρίτο μέρος-συνεργάτη, η χρήση των
        πληροφοριών απότην Εταιρεία θα διέπεται από την παρούσα Πολιτική
        Απορρήτου.
      </p>
      <p className="fs-4">
        Στην παρούσα Πολιτική περιγράφονται τα είδη των άλλων εταιρειών που
        ενδέχεται να επιθυμούν αποστολή πληροφοριών εσάς σχετικά με τα προϊόντα
        και υπηρεσίες τους και επομένως επιθυμούν να μοιραστούν τα προσωπικά
        δεδομένα σας, με την προϋπόθεση πως εσείς έχετε δώσει στην Εταιρεία την
        ρητή συγκατάθεση σας για να το πράξει.
      </p>
      <p className="fs-4">
        Ο ιστότοπος της Εταιρείας μπορεί, επίσης, να συνδέεται με τοποθεσίες που
        λειτουργούν από σχετιζόμενες εταιρείες με την Εταιρεία, όπως εταιρείες
        που είναι μέλη του Ομίλου της Εταιρείας. Αν και τα μέλη του Ομίλου της
        Εταιρείας τηρούν τους κανόνες του Ομίλου, τα υποκείμενα των προσωπικών
        δεδομένων που επισκέπτονται αυτές τις σχετιζόμενες τοποθεσίες θα πρέπει
        να ανατρέχουν στις ξεχωριστές πολιτικές απορρήτου και πρακτικές τους, οι
        οποίες ενδέχεται να διαφέρουν σε ορισμένα θέματα από την παρούσα
        Πολιτική.
      </p>
      <p className="fs-4">
        Τρίτος, εκτελών την επεξεργασία για λογαριασμό της Εταιρείας, όπως
        ενδεικτικά ένας πάροχος υπηρεσιών, υποχρεούται να συμφωνήσει συμβατικά
        για την επεξεργασία προσωπικών δεδομένων σύμφωνα με την παρούσα πολιτική
        ενώ οι όροι αυτής της πολιτικής συμπεριλαμβάνονται στις σχετικές
        συμβάσεις.
      </p>
      <p className="fs-4">
        Είναι δυνατή αποκάλυψη των προσωπικών δεδομένων σε τρίτους μόνον εφόσον
        είναι απαραίτητο ή εφόσον το υποκείμενο χορηγήσει τη ρητή συγκατάθεσή
        του. Τα δεδομένα προσωπικού χαρακτήρα πρέπει να παρέχονται ανωνύμως,
        εφόσον κρίνεται σκόπιμο.
      </p>
      <p className="fs-4">
        Επίσης, η Εταιρεία δύναται να χρησιμοποιεί τα προσωπικά δεδομένα στο
        σύνολό τους, ανώνυμα, για ερευνητικούς σκοπούς.
      </p>
      <p className="fs-4">
        Συνεργαζόμενες τρίτες εταιρείες με την Εταιρεία μπορούν να προσφέρουν
        λήψεις δεδομένων και αρχείων στα υποκείμενα για λογαριασμό της
        Εταιρείας, συλλέγοντας προσωπικά δεδομένα εκ μέρους της Εταιρείας, όταν
        τα υποκείμενα πραγματοποιούν εγγραφή ή συνδέονται για μεμονωμένες λήψεις
        αρχείων και υπηρεσιών μέσω του κινητού τηλεφώνου τους. Τότε, η
        συνεργαζόμενη τρίτη εταιρεία παρέχει στην Εταιρεία τα προσωπικά δεδομένα
        που χρειάζεται για να προσφέρει στα υποκείμενα των δεδομένων λήψεις
        πληροφοριών και αρχείων της Εταιρείας και άλλες υπηρεσίες που έχουν
        αιτηθεί. Η συνεργάτης τρίτη εταιρεία της Εταιρείας παρέχει ακόμη στον
        πάροχο κινητής τηλεφωνίας του υποκειμένου των δεδομένων τις πληροφορίες
        που χρειάζεται για να προχωρήσει στις απαραίτητες χρεώσεις για τις
        λήψεις πληροφοριών και αρχείων και για άλλες υπηρεσίες που αγόρασε.
      </p>
      <p className="fs-4">
        Η Εταιρεία διατηρεί την δυνατότητα να μοιραστεί τα προσωπικά δεδομένα
        των υποκειμένων με συνεργαζόμενες εταιρείες με αυτήν ή με εταιρείες που
        ανήκουν στον όμιλο της Εταιρείας, προς επίτευξη πάντοτε του σκοπού της
        επεξεργασίας.
      </p>
      <p className="fs-4">
        Προς επίτευξη όλων των παραπάνω, κάθε υπάλληλος της Εταιρείας λαμβάνει
        την απαραίτητη εκπαίδευση σε θέματα προστασίας δεδομένων και ασφάλειας
        δεδομένων. Για να είναι επιτρεπτή η πρόσβαση των υπαλλήλων, αντιπροσώπων
        και συνεργατών της Εταιρείας πρέπει να δικαιολογείται από νόμιμο λόγο.
      </p>
      <p className="fs-4">
        Η Εταιρεία έχει την δυνατότητα διαμοιρασμού των προσωπικών δεδομένων των
        υποκειμένων με εξωτερικούς συνεργάτες ή αντιπροσώπους της, οι οποίοι την
        συνδράμουν στη διαχείριση των πληροφοριακών δραστηριοτήτων της (π.χ.
        εκπλήρωση παραγγελιών, στατιστικές αναλύσεις). Ωστόσο, σε αυτή την
        περίπτωση οι ανωτέρω μπορούν να χρησιμοποιήσουν τα εν λόγω δεδομένα μόνο
        για να παρέχουν στην Εταιρεία συγκεκριμένη υπηρεσία και όχι για
        οποιονδήποτε άλλο σκοπό.
      </p>
      <p className="fs-4">
        Η Εταιρεία μπορεί να συμβληθεί με τρίτες εταιρείες που κατέχουν την
        τεχνολογία που επιτρέπει στην Εταιρεία να προσαρμόσει τα διαφημιστικά
        και μάρκετινγκ μηνύματα που λαμβάνει το υποκείμενο στις διαδικτυακές
        τοποθεσίες της Εταιρείας. Τα μη προσωπικά δεδομένα και το ιστορικό
        περιήγησης στο διαδίκτυο σχετικά με τις δραστηριότητές των υποκειμένων
        στις τοποθεσίες αυτές μπορεί να μοιράζονται με αυτές τις εταιρείες, έτσι
        ώστε αυτή η προσαρμογή να μπορεί να επιτευχθεί. Αυτές οι εταιρείες δεν
        θα μοιραστούν τις παραπάνω πληροφορίες με οποιοδήποτε τρίτο μέρος, ούτε
        θα τις χρησιμοποιήσουν για οποιονδήποτε άλλο σκοπό. Ενδέχεται όμως να
        γίνει χρήση, ανώνυμα, του ιστορικού περιήγησης και άλλων δημογραφικών
        πληροφοριών αποκλειστικά για διαφημιστικούς-στατιστικούς σκοπούς από την
        Εταιρεία ή τους επιχειρηματικούς συνεργάτες της.
      </p>

      <h1>10. Αποθήκευση, Χρόνος Διατήρησης και Ασφάλεια των Δεδομένων</h1>
      <p className="fs-4">
        Ο χρόνος αποθήκευσης των προσωπικών δεδομένων καθορίζεται από τον χρόνο
        που απαιτείται για την εκπλήρωση του σκοπού συλλογής τους καθώς και από
        το νόμο. Τα στοιχεία της αποθήκευσης δεδομένων και των περιόδων
        διατήρησης καθορίζονται στην Πολιτική Διατήρησης Δεδομένων της
        Εταιρείας.
      </p>
      <p className="fs-4">
        Η Εταιρεία φροντίζει για την λήψη όλων των ενδεικνυόμενων από την
        σύγχρονη τεχνολογία, οργανωτικών και μη μέτρων, προς το σκοπό διαφύλαξης
        των προσωπικών δεδομένων που βρίσκονται στην κατοχή της έναντι των
        κινδύνων απώλειας, κλοπής και μη εξουσιοδοτημένης χρήσης, αποκάλυψης ή
        τροποποίησης με στόχο την εξασφάλιση της ακεραιότητας, της
        εμπιστευτικότητας και της διαθεσιμότητάς τους. Η Εταιρεία χρησιμοποιεί
        επίσης, εύλογες μεθόδους προς επιβεβαίωση ότι τα τηρούμενα προσωπικά
        δεδομένα είναι ακριβή, ενημερωμένα και κατάλληλα συμπληρωμένα.
      </p>

      <h1>11. Περιπτώσεις Αποκάλυψης των Προσωπικών Δεδομένων</h1>
      <p className="fs-4">
        Οι περιπτώσεις που η Εταιρεία δικαιούται να αποκαλύψει τα προσωπικά
        δεδομένα των υποκειμένων χωρίς την συγκατάθεση τους, είναι οι εξής: α)
        προστασία νομίμων δικαιωμάτων της Εταιρείας ή άλλων εταιρειών εντός του
        Ομίλου της Εταιρείας ή των υπαλλήλων, αντιπροσώπων και συνεργατών της,
        β) για την ασφάλεια των επισκεπτών του ιστότοπού της, γ) για προστασία
        έναντι απάτης ή σε οποιαδήποτε περίπτωση τελέσεως ή υποψίας τελέσεως
        αξιόποινης πράξης, δ) για λόγους διαχείρισης κινδύνου, δημόσιας τάξης
        και ασφάλειας, εθνικού συμφέροντος, ε) εάν αυτό ζητηθεί αρμοδίως από τις
        κρατικές ή δικαστικές αρχές και στ) για συμμόρφωση της Εταιρείας με τις
        διατάξεις της νομοθεσίας ή τις νόμιμες διαδικασίες.
      </p>

      <h1>12. Προϋποθέσεις διασυνοριακής αποκάλυψης προσωπικών δεδομένων</h1>
      <p className="fs-4">
        Είναι εφικτή η αποκάλυψη των προσωπικών δεδομένων στο εξωτερικό μόνο
        εφόσον το νομοθετικό πλαίσιο της χώρας όπου επιχειρείται η αποκάλυψη
        παρέχει επαρκές και ικανοποιητικό επίπεδο προστασίας των προσωπικών
        δεδομένων.
      </p>
      <p className="fs-4">
        Άλλως, τα δεδομένα προσωπικού χαρακτήρα μπορούν να μεταφερθούν σε αυτή
        τη χώρα μόνο υπό την προϋπόθεση ότι το πρόσωπο στο οποίο αναφέρονται
        έχει συναινέσει ρητά στη μεταφορά ή εάν υπάρχει σχετική συμφωνίας περί
        μεταφοράς δεδομένων, με την οποία παρέχονται όλες οι απαραίτητες
        εγγυήσεις για τη προστασία τους.
      </p>

      <h1>13. Μεταβίβαση Εταιρείας</h1>
      <p className="fs-4">
        Αν η Εταιρεία πωλήσει μέρος ή όλη την επιχείρησή της ή πραγματοποιήσει
        μια πώληση ή μεταφορά περιουσιακών στοιχείων ή εμπλακεί γενικότερα σε
        μια συγχώνευση ή μεταφορά επιχείρησης, η Εταιρεία μπορεί να μεταφέρει τα
        προσωπικά δεδομένα των υποκειμένων σε ένα τρίτο μέρος ως τμήμα αυτής της
        συναλλαγής.
      </p>

      <h1>14. Τροποποίηση των όρων της Πολιτικής Απορρήτου</h1>
      <p className="fs-4">
        Οι παραπάνω όροι αποτελούν την πλήρη συμφωνία με την Εταιρεία, η οποία
        διατηρεί το δικαίωμα να τροποποιεί ή να ανανεώνει ή να διαγράφει όλους
        τους όρους του παρόντος, χωρίς καμία προειδοποίηση. Η τροποποίηση ή
        ανανέωση θα ισχύει από την στιγμή που θα ενημερωθεί σχετικά το παρόν
        κείμενο για οποιαδήποτε αλλαγή. Επομένως, το υποκείμενο θα πρέπει να την
        εξετάζει τακτικά ώστε να είναι ενήμερο σχετικά με τις πλέον πρόσφατες
        πολιτικές και πρακτικές της Εταιρείας. Εάν η Εταιρεία αλλάξει ουσιωδώς
        τις πρακτικές της αναφορικά με τη συλλογή ή χρήση των προσωπικών
        δεδομένων, τα προσωπικά δεδομένα των υποκειμένων θα συνεχίσουν να
        διέπονται από την Πολιτική κάτω από την οποία έγινε η συλλογή τους,
        εκτός αν έχει παρασχεθεί σχετική ειδοποίηση και το υποκείμενο δεν είχε
        αντίρρηση για την αλλαγή.
      </p>

      <h1>
        15. Επίλυση θεμάτων προστασίας Προσωπικών Δεδομένων-Τρόποι Επικοινωνίας
      </h1>
      <p className="fs-4">
        Για την άσκηση των δικαιωμάτων σας, όπως για την επίλυση θεμάτων
        απορρήτου, για θέματα σχετικά με τη συλλογή και επεξεργασία των
        προσωπικών δεδομένων σας από την Εταιρεία, για να ασκήσετε το δικαίωμα
        αναθεώρησης, διόρθωσης, διαγραφής των προσωπικών δεδομένων σας ή
        διακοπής κάθε μελλοντικής επικοινωνίας μαζί σας, μπορείτε να
        επικοινωνήσετε με την Εταιρεία στην ηλεκτρονική διεύθυνση
        support@psmsgreece.gr,με την εξυπηρέτηση πελατών τηλ. 2104445975 ή με
        επιστολή που αποστέλλετε στην έδρα της Εταιρείας που βρίσκονται στην
        DSO-THUB-G-D-FLEX-G003E , building THUB, Dubai Silicon Oasis , Dubai.
      </p>
    </>
  );
}
